import { Injectable } from "@angular/core";

@Injectable({
	providedIn: "root"
})
export class NestedObjectCheckerService {
	constructor() {}

	public checkNestedObject(path: string, object: any): any {
		const transformedPath = this.__convertPathToArray(path);
		return transformedPath.reduce((xs, x) => (xs && xs[x] ? xs[x] : null), object);
	}

	private __convertPathToArray(path: string): any[] {
		path = path.replace(/\[/gm, ".").replace(/\]/gm, "");
		return path.split(".");
	}
}
